import React from 'react'
import Image from 'next/image'
import { useAngelContent } from '@/services/hooks/useContent/useContent'
import Type from '../Type'

const GUILD_MEMBERSHIP_NUMBERS_ENTRY_ID = '6jIe1S7pgjYmMceUTUTdS1'

const GuildLiveCount: React.FC = () => {
  const { content, isLoading } = useAngelContent(
    GUILD_MEMBERSHIP_NUMBERS_ENTRY_ID
  )

  return (
    <div className="bg-core-gray-900 border-2 border-core-copper rounded-lg p-4 mb-6 text-white">
      <div className="flex w-full max-w-[376px] items-center gap-4 mx-auto">
        <Image
          src="https://images.angelstudios.com/image/upload/v1704922101/angel-app/guild/angel-guild-logo-full"
          alt="Angel Guild"
          width={32}
          height={40}
        />
        <Type variant="caption-sm" as="p" className="uppercase">
          Guild Members
          <br />
          Changing the industry
        </Type>
        {!isLoading && content?.fields?.customData?.[0]?.numSubscribers && (
          <Type variant="heading-sm" as="p" className="flex-1 text-right">
            {content.fields.customData[0].numSubscribers.toLocaleString()}
          </Type>
        )}
      </div>
    </div>
  )
}

export default GuildLiveCount
